import React, {useEffect} from 'react';
import {StyleSheet, Text, View} from "react-native";
import {useDispatch, useSelector} from 'react-redux';
import {formatTimeFromMoment} from "../services/helpers/dateTimeHelpers";
import {
    getConfig,
    getConnectionStatus,
    getCurrentBooking,
    getMaintenance,
    getNextBooking,
    getRoomStatus,
    setRoomStatus
} from "../reducers/configSlice";
import {ROOM_STATUS_BUSY, ROOM_STATUS_FREE, ROOM_STATUS_WAITING} from "../constants/default";
import moment from "moment";
import {deviceLeds} from "../services/deviceLeds";
import {FONT_FAMILY_BOLD, FONT_FAMILY_BOLDER} from "../constants/styleConstants";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";

const Color = require('color');

const RoomStatus = ({ hidden }) => {
    const dispatch = useDispatch()
    const currentBooking = useSelector(getCurrentBooking)
    const nextBooking = useSelector(getNextBooking)
    const roomStatus = useSelector(getRoomStatus)
    const connectionStatus = useSelector(getConnectionStatus)
    const config = useSelector(getConfig)
    const maintenance = useSelector(getMaintenance)

    useEffect( () => {
        if (currentBooking) {
            dispatch(setRoomStatus(!currentBooking.checkin && config.has_checkin ? ROOM_STATUS_WAITING : ROOM_STATUS_BUSY))

            const ledsState = !currentBooking.checkin && config.has_checkin ? 'checkin' : 'busy';
            deviceLeds(ledsState, config?.light_driver)
        } else {
            dispatch(setRoomStatus(ROOM_STATUS_FREE))
            deviceLeds('available', config?.light_driver)
        }
    }, [currentBooking, nextBooking])

    const getStatusDetails = (status) => {
        if (maintenance) {
            deviceLeds('off', config?.light_driver)

            return {
                text: translate("Maintenance"),
                color: '#b5b5b5',
                due: translate("until %s", [moment(maintenance.end).format(config.date_format) + ' ' + formatTimeFromMoment(moment(maintenance.end), config.time_format)])
            }
        } else if (status === ROOM_STATUS_BUSY) {
            return {
                text: translate("Room busy"),
                color: '#E83948',
                due: currentBooking ?
                    translate("until %s", [formatTimeFromMoment(moment(currentBooking.end), config.time_format)]) :
                    translate("for the rest of the day")
            }
        } else if (status === ROOM_STATUS_WAITING) {
            return {
                text: translate("Waiting for confirmation"),
                color: '#DD9E3B',
                due: currentBooking ? translate("until %s", [formatTimeFromMoment(moment(currentBooking.start).add(config.grace_period, 'minutes'), config.time_format)]) : null
            };
        } else {
            return {
                text: translate("Room available"),
                color: Color('#82BF68').alpha(1).lighten(0).hex(),
                due: nextBooking ?
                    translate("until %s", [formatTimeFromMoment(moment(nextBooking.start), config.time_format)]) :
                    translate("for the rest of the day")
            };
        }
    }

    return (
        roomStatus !== null && !hidden && <View style={[styles.footer, {backgroundColor: getStatusDetails(roomStatus).color}, !connectionStatus && {opacity: 0.6}]}>
            <Text style={[styles.roomStatus, {fontFamily: FONT_FAMILY_BOLDER}, maintenance ? styles.maintenance : null]}>{getStatusDetails(roomStatus).text} </Text>
            <Text style={[styles.roomStatus, maintenance ? styles.maintenance : null]}>{getStatusDetails(roomStatus).due}</Text>
        </View>
    );
};

const determineRoomStatus = (currentBooking, config) => {
    if (currentBooking) {
        return !currentBooking.checkin && config.has_checkin ? ROOM_STATUS_WAITING : ROOM_STATUS_BUSY;
    }
    return ROOM_STATUS_FREE;
};

const styles = StyleSheet.create({
    footer: {
        flex: 0.13,
        flexDirection: 'row',
        paddingLeft: '8%'
    },
    roomStatus: {
        alignSelf:'center',
        fontFamily: FONT_FAMILY_BOLD,
        color: '#FFFFFF',
        fontSize: actuatedNormalize(16)
    },
    maintenance: {
        color: '#000000'
    }
});

export default RoomStatus;
